import React, { useState, useEffect } from "react";
import { Link, useStaticQuery, graphql } from "gatsby";
import { AiOutlineCaretRight } from "react-icons/ai";
import { MdMenu, MdClose } from "react-icons/md";
import "./styles.scss";
import SubMenuMobile from "../SubMenuMobile";
import SocialLinks from "../SocialLinks";
import LogoMobile from "../../images/logo-mobile.svg";

function MobileNav() {
	// Default menu state is set to an empty string to have 0 menus open
	const [activeMobileMenu, setActiveMobileMenu] = useState("");

	const handleActiveMobileMenu = menuToOpen => {
		if (menuToOpen === activeMobileMenu) {
			setActiveMobileMenu("");
			return;
		}

		setActiveMobileMenu(menuToOpen);
	};

	useEffect(() => {
		if (activeMobileMenu) {
			document.querySelector("body").classList.add("mobile-nav-open");
		} else {
			document.querySelector("body").classList.remove("mobile-nav-open");
		}
	}, [activeMobileMenu]);

	const data = useStaticQuery(graphql`
		query MobileMenuData {
			contentfulMenu(title: { eq: "Mobile Main Menu" }) {
				menuItems {
					contentful_id
					title
					slug
					subMenu {
						menuItems {
							contentful_id
							title
							slug
							description
							icon {
								svg {
									content
								}
							}
						}
					}
				}
			}
		}
	`);

	const mobileMenuNavLinks = data.contentfulMenu.menuItems;

	return (
		<header className="section section--is-dark section--is-paddingless mobile-nav">
			<div className="mobile-nav__bar">
				<div className="mobile-nav__logo">
					<Link to="/">
						<img
							src={LogoMobile}
							alt="Irish Titan"
							width="162px"
							height="30px"
						/>
					</Link>
				</div>
				<div className="mobile-nav__icon">
					<button
						className="btn btn--reset"
						onClick={() => handleActiveMobileMenu("primary")}
					>
						{activeMobileMenu ? (
							<MdClose title={`Close Menu`} size={32} />
						) : (
							<MdMenu title={`Open Menu`} size={32} />
						)}
					</button>
				</div>
			</div>
			{activeMobileMenu && (
				<div className="mobile-nav__primary-panel">
					<ul className="mobile-nav__nav-links">
						{mobileMenuNavLinks.map((menuItem, index) => {
							if (menuItem.subMenu) {
								return (
									<li key={index}>
										<button
											className="btn btn--link mobile-nav__nav-links-item"
											onClick={() => handleActiveMobileMenu(menuItem.title)}
											aria-haspopup="true"
											aria-expanded={
												activeMobileMenu === menuItem.title ? "true" : "false"
											}
										>
											{menuItem.title}
											<AiOutlineCaretRight
												aria-hidden="true"
												size={16}
												className="mobile-nav__nav-link-caret"
											/>
										</button>
										<SubMenuMobile
											title={menuItem.title}
											menuItems={menuItem.subMenu.menuItems}
											activeMobileMenu={activeMobileMenu}
											handleActiveMobileMenu={handleActiveMobileMenu}
										/>
									</li>
								);
							} else {
								return (
									<li key={index}>
										<Link className="mobile-nav__nav-links-item" to={`/${menuItem.slug}`}>{menuItem.title}</Link>
									</li>
								);
							}
						})}
					</ul>

					<div className="mobile-nav__contact-us">
						<Link to="/contact" className="btn btn--green-white">
							Contact Us
						</Link>
					</div>

					<div className="mobile-nav__contact-methods">
						<a href={`tel:612-200-1015`}>612-200-1015</a>
						<a href={`mailto:info@irishtitan.com`}>info@irishtitan.com</a>
					</div>

					<SocialLinks classModifier={`social-links__mobile-nav`} />
				</div>
			)}
		</header>
	);
}

export default MobileNav;
